import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { useFormikContext } from 'formik';
export const FormikButton = props => {
    const { variant, color, children } = props;
    const { dirty, isValid, isSubmitting } = useFormikContext();
    return (React.createElement(Button, Object.assign({ type: 'submit', variant: variant || 'contained', color: color || 'primary', disabled: !dirty || !isValid || isSubmitting, endIcon: isSubmitting && React.createElement(CircularProgress, { color: 'primary', size: 20 }) }, props), children));
};
export default FormikButton;
//# sourceMappingURL=FormikButton.js.map